<template>
  <div>
    <div class="wrapper">
      <SideBar2 />

      <div class="main-panel">
        <TopBar />
        <div class="row" style="margin:0">
          <div class="col-lg-9 col-12">
            <Slide />
            <div class="content">
              <div class="container-fluid">
                  <div class="row mx-0 div-title-block" style="margin: 10px 30px 30px 30px">
                    <h4 style="font-weight: bold">Nearby Shops</h4>
                    <div class="hr-title"></div>
                  </div>
                <div class="list-shop row col-lg-12">
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6" style="">
                    <img class="card-img-top img-shop-list" src="https://w7.pngwing.com/pngs/406/577/png-transparent-grocery-store-convenience-shop-retail-computer-icons-store-food-company-text-thumbnail.png" alt="Card image cap">
                    <div class="card-body">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Card title</h5>
                      <p class="card-text">Ha Noi - Viet Nam</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
         <Cart />
        </div>
      </div>
      </div>
    </div>
</template>

<script>
import TopBar from "./TopBar";
import SideBar2 from "./SideBar2";
import Slide from "../components/Slide";
import Cart from "../components/Cart";
export default {
  name: "ListShop2",
  components: {Cart, Slide, SideBar2, TopBar}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ListShop2.vue